export default {
    breakWord: {
        wordBreak: 'break-word',
    },
    breakAll: {
        wordBreak: 'break-all',
    },
};
